const AssignCustomers = () =>
  import('@/views/main/wechatMgmt/assignCustomers/AssignCustomers.vue')
export default {
  path: '/main/wechatMgmt/assignCustomers',
  name: 'AssignCustomers',
  component: AssignCustomers
}
